<template>
    <div class="tw-mt-8">
        <form>
            <fieldset class="input-wrapper tw-mt-4">
                <label for="fullname" class="tw-text-base tw-font-semibold">{{
                    translate('customerInfoAndPayment.form.fullname')
                }}</label>
                <input
                    type="text"
                    class="input-field-app"
                    name="fullname"
                    id="fullname"
                    v-model.trim="customer.fullname"
                />

                <div class="error-message" v-if="v$.customer.fullname.$error">
                    <div>
                        <img :src="WarningIcon" alt="Warning" />
                    </div>
                    <div>
                        <span>{{ translate('customerInfoAndPayment.errors.required') }}</span>
                    </div>
                </div>
            </fieldset>
            <fieldset class="input-wrapper tw-mt-4">
                <label for="country" class="tw-text-base tw-font-semibold">{{
                    translate('customerInfoAndPayment.form.country')
                }}</label>
                <select name="country" id="country" class="dropdown-menu" v-model="customer.countryId">
                    <option disabled :value="null" class="dropdown-menu-item">
                        {{ translate('customerInfoAndPayment.form.country_select') }}
                    </option>
                    <option class="dropdown-menu-item" v-for="state in countries" :key="state.id" :value="state.id">
                        {{ state.country_name }}
                    </option>
                </select>
                <div class="error-message" v-if="v$.customer.countryId.$error">
                    <div>
                        <img :src="WarningIcon" alt="Warning" />
                    </div>
                    <div>
                        <span>{{ translate('customerInfoAndPayment.errors.required') }}</span>
                    </div>
                </div>
            </fieldset>
            <fieldset class="input-wrapper tw-mt-4">
                <label for="email-address" class="tw-text-base tw-font-semibold">{{
                    translate('customerInfoAndPayment.form.email')
                }}</label>
                <input
                    type="text"
                    class="input-field-app"
                    name="email"
                    id="email-address"
                    v-model.trim="customer.email"
                />
                <div class="error-message" v-if="v$.customer.email.$error">
                    <div>
                        <img :src="WarningIcon" alt="Warning" />
                    </div>
                    <div>
                        <span>{{ translate('customerInfoAndPayment.errors.email') }}</span>
                    </div>
                </div>
            </fieldset>
            <fieldset ref="contact-input" class="input-wrapper tw-mt-4">
                <label for="contact-number" class="tw-text-base tw-font-semibold">{{
                    translate('customerInfoAndPayment.form.phone')
                }}</label>
                <div class="inline-dropdown-container">
                    <select
                        id="country-code"
                        class="dropdown-menu-small tw-mr-2"
                        v-model="customer.contact.code"
                        name="country-code"
                    >
                        <option disabled :value="null">
                            {{ translate('customerInfoAndPayment.form.country_code') }}
                        </option>
                        <option v-for="code in callingCodes" :key="code" :value="code">+{{ code }}</option>
                    </select>
                    <input
                        type="text"
                        class="input-field-app"
                        name="contactNumber"
                        id="contact-number"
                        v-model.trim="customer.contact.number"
                    />
                </div>
                <div class="error-message" v-if="v$.customer.contact.code.$error || v$.customer.contact.number.$error">
                    <div>
                        <img :src="WarningIcon" alt="Warning" />
                    </div>
                    <div>
                        <span>{{ translate('customerInfoAndPayment.errors.contact_number') }}</span>
                    </div>
                </div>
                <!-- BE error for phone number -->
                <div class="error-message" v-if="customerInfoBackendErrors.number">
                    <div>
                        <img :src="WarningIcon" alt="Warning" />
                    </div>
                    <div>
                        <span v-for="message in customerInfoBackendErrors.number" :key="message">
                            {{ message }}
                        </span>
                    </div>
                </div>
                <div class="tw-text-sm tw-text-grey tw-text-center tw-mt-5 connect-disclaimer">
                    {{ translate('customerInfoAndPayment.smsDisclaimer') }}
                </div>
            </fieldset>
            <fieldset class="input-wrapper tw-mt-4">
                <label for="message" class="tw-text-base tw-font-semibold">{{
                    translate('customerInfoAndPayment.form.message')
                }}</label>
                <textarea
                    class="textarea-app tw-mt-4"
                    name="message"
                    id="message"
                    :placeholder="translate('customerInfoAndPayment.form.message_placeholder')"
                    v-model="customer.message"
                ></textarea>
            </fieldset>
            <!-- <fieldset class="input-wrapper tw-mt-4">
                <div class="radio-checkbox-item">
                    <label>
                        <input type="checkbox" v-model="customer.smsNotification" />
                        <span class="radio-checkbox-label small">{{
                            translate('customerInfoAndPayment.form.notification')
                        }}</span>
                    </label>
                </div>
            </fieldset> -->
            <fieldset class="input-wrapper tw-mt-4">
                <div class="radio-checkbox-item">
                    <label>
                        <input type="checkbox" v-model="customer.newsletter" />
                        <span class="radio-checkbox-label small">{{
                            translate('customerInfoAndPayment.form.newsletter')
                        }}</span>
                    </label>
                </div>
            </fieldset>
            <div class="links-container tw-my-4 tw-flex tw-flex-row tw-items-center tw-justify-start">
                <a :href="`/${lang}/privacy-policy`" target="_blank" class="tw-mr-4 tw-underline tw-font-semibold">
                    {{ translate('customerInfoAndPayment.links.privacy_policy') }}
                </a>
                <a
                    :href="`/${lang}/site-terms-conditions`"
                    target="_blank"
                    class="tw-mr-4 tw-underline tw-font-semibold"
                >
                    {{ translate('customerInfoAndPayment.links.terms_and_conditions') }}
                </a>
            </div>
            <div class="btn-container tw-my-4">
                <button @click.prevent="sendCustomerInfo" class="btn btn-tertiary btn-md btn-fw">
                    {{ translate('customerInfoAndPayment.form.next') }}
                </button>
            </div>
        </form>
        <div
            class="tw-text-xs tw-leading-tight tw-text-center tw-border tw-border-solid tw-border-blue tw-rounded-4 tw-p-2 tw-text-dark-grey support-message"
            v-html="translate('booking.info', { phone: phoneLink, email: emailLink })"
        ></div>
    </div>
</template>
<script>
import i18n from '@js/vue/mixins/i18n';
import useVuelidate from '@vuelidate/core';
import { required, email } from '@vuelidate/validators';
import WarningIcon from '@images/warning-24px.svg';
import { BOOKING_VIEWS } from '@js/vue/booking-views.js';
import { mapGetters, mapActions } from 'vuex';
import { trackPersonalInfoSubmitted } from '@js/vue/dataLayerUtils.js';
import { contactInfo } from '@js/vue/contact-info.js';

export default {
    name: 'CustomerInfo',
    mixins: [i18n],
    inject: ['lang', 'translations'],
    props: ['activeView'],
    setup() {
        return { v$: useVuelidate() };
    },
    data() {
        return {
            WarningIcon,
            customer: {
                fullname: '',
                email: '',
                countryId: null,
                contact: {
                    code: '',
                    number: '',
                },
                smsNotification: false,
                newsletter: false,
                message: '',
                number: '',
            },
            customerInfoBackendErrors: {},
            callingCodes: [],
            countries: [],
            BOOKING_VIEWS,
            phoneLink: `<a class="tw-whitespace-nowrap tw-underline" href="tel:${contactInfo.phoneNumber}">${contactInfo.phoneNumber}</a>`,
            emailLink: `<a class="tw-whitespace-nowrap tw-underline" href="mailto:${contactInfo.emailAddress}">${contactInfo.emailAddress}</a>`,
        };
    },
    validations() {
        return {
            customer: {
                fullname: { required },
                email: { required, email },
                countryId: { required },
                contact: {
                    code: { required },
                    number: { required },
                },
            },
        };
    },
    methods: {
        ...mapActions('booking', ['sendCustomer']),
        fetchCallingCodes() {
            axios.get('/api/helpers/phone/calling-codes').then((response) => {
                this.callingCodes = response.data;
            });
        },
        fetchCountries() {
            axios.get('/api/helpers/countries').then((response) => {
                this.countries = response.data;
            });
        },
        sendCustomerInfo() {
            this.customerInfoBackendErrors = {};
            this.v$.$touch();
            if (!this.v$.$invalid) {
                // prepend the plus sign, combine calling code and number
                this.customer.number = `+${this.customer.contact.code}${this.customer.contact.number}`;
                this.sendCustomer({ id: this.id, customer: this.customer })
                    .then(() => {
                        if (window.fpr) window.fpr('referral', { email: this.customer.email });
                        trackPersonalInfoSubmitted(
                            this.title,
                            this.regionCategorySlugs['region-slug'],
                            this.regionCategorySlugs['category-slug'],
                            this.totalPrice
                        );
                        this.$emit('changeView', BOOKING_VIEWS.PAYMENT_ACTION_VIEW);
                    })
                    .catch((error) => {
                        const { status } = error.response;
                        if (status === 422) {
                            // unprocessable data, display backend errors
                            this.customerInfoBackendErrors = error.response.data.errors;
                        } else if (status === 419 || status === 404) {
                            // 419 csrf token mismatch (session expired)
                            // 404 cart not in session (probably expired session)
                            this.$emit('error', 'session_expired');
                        } else {
                            // something else went wrong
                            console.dir(error);
                            this.$emit('error', 'something_went_wrong');
                        }
                    });
            }
        },
    },
    computed: {
        ...mapGetters('booking', [
            'getServiceTitle',
            'getServiceId',
            'getRegionCategorySlugs',
            'getTotalPrice',
            'getCustomer',
        ]),
        title() {
            return this.getServiceTitle;
        },
        id() {
            return this.getServiceId;
        },
        regionCategorySlugs() {
            return this.getRegionCategorySlugs;
        },
        totalPrice() {
            return this.getTotalPrice;
        },
        storedCustomer() {
            return this.getCustomer;
        },
    },
    created() {
        this.fetchCallingCodes();
        this.fetchCountries();
        // customer data already set
        if (this.storedCustomer) {
            this.customer = JSON.parse(JSON.stringify(this.storedCustomer));
        }
    },
};
</script>
